import React, { useContext, useState, useEffect } from 'react';
import { map, find, sortBy } from 'lodash';
import { FocusBaseContext, MarkupContext } from '../../../contexts';
import Dropdown from '../../../../../common/dropdown';
import { conceptDropdownStyles } from '../../../../../common/dropdown/styles';
import { updateRegionRequest } from '../../../requests';
import { stringifyFilterData } from "../../../../../../express/researcher/common/helpers";

const RegionSettings = () => {
  const {
    selectedConceptId,
    conceptById, selectedRegionId, updateSelectedRegionId, markupTool,
    saveUserSettings, refreshRegionData, onMarkupSettingsChange, setRegions,
    currentSummary, findSelectedRegion
  } = useContext(FocusBaseContext);
  const { createMode, setRegionModal, currentFilters } = useContext(MarkupContext);
  const [ defaultRegion, setDefaultRegion ] = useState(() => ({ id: "", name: "No Region" }));
  useEffect(() => {
    defaultRegion.name = (createMode ? "New Region" : "No Region");
    setDefaultRegion({ ...defaultRegion });
  }, [ createMode ]);
  const concept = conceptById();
  const regions = (sortBy(concept.regions, (item) => item.id) || []);
  const selectedRegion = findSelectedRegion(regions, selectedRegionId);

  const regionsList = map([ ...[ defaultRegion ], ...(regions || []) ], (el) => ({ value: el.id, label: el.name }));
  const selectedRegionItem = find(
    regionsList,
    (el) => (el.value === selectedRegionId || (!el.value && !selectedRegionId))
  );

  const handleChangeRegion = (item) => {
    const selectedId = item.value || null;
    saveUserSettings({
      region_id: selectedId,
      concept_id: selectedConceptId()
    });
    updateSelectedRegionId(item.value || null);
    markupTool.setRegions(concept.regions, selectedId);
    if (selectedId !== null) {
      const selectedRegion = findSelectedRegion(regions, selectedId);
      updateRegionRequest(
        selectedRegion.update_path,
        {
          positive: markupTool.reactions.positive,
          negative: markupTool.reactions.negative,
          confusing: markupTool.reactions.confusing,
          markup_type: markupTool.markupType,
          filters: currentFilters(), filter_data: stringifyFilterData([ ...currentSummary.filter ])
        },
        (response) => {
          setRegions(response.data.regions);
        });
    }
    onMarkupSettingsChange();
  };

  const handleChangeClipMode = (event) => {
    const newClipMode = event.target.value;
    selectedRegion.clip_mode = newClipMode;
    markupTool.setClipMode(newClipMode);
    updateRegionRequest(selectedRegion.update_path, { clip_mode: newClipMode },
      (response) => {
        setRegions(response.data.regions);
      });
    refreshRegionData();
    onMarkupSettingsChange();
  };

  const isClipMode = (mode) => (selectedRegion?.clip_mode === mode);

  const handleOpenEditModal = () => {
    setRegionModal(selectedRegion);
  };

  useEffect(() => {
    if (createMode) {
      handleChangeRegion({});
    }
  }, [ createMode ]);

  return (
    <>
      <div className="page-row">
        <div className="page-row_col">
          <div className="form-label">Region:</div>
          <div className="summary-markup_form">
            <Dropdown
              value={ selectedRegionItem }
              searchable
              options={ regionsList }
              onChange={ handleChangeRegion }
              customStyles={ conceptDropdownStyles }
              disabled={ createMode }
            />
            {
              !!selectedRegion?.id && !createMode &&
              <button className="button -edit" onClick={ handleOpenEditModal }>Edit</button>
            }
          </div>
        </div>
      </div>
      <div className="page-row">
        <div className="page-row_col -none">
          <div className="form-label" />
          <div className="summary-markup_regions">
            <input
              className="hide"
              type="radio"
              id="region1"
              name="region_type"
              disabled={ !selectedRegion?.id }
              value="inside"
              checked={ isClipMode('inside') }
              onChange={ handleChangeClipMode }
            />
            <label className="inside" htmlFor="region1">
              <svg className="icon -region1"><use xlinkHref="#svg_region1" /></svg>
            </label>

            <input
              className="hide"
              type="radio"
              id="region2"
              name="region_type"
              disabled={ !selectedRegion?.id }
              value="covered"
              checked={ isClipMode('covered') }
              onChange={ handleChangeClipMode }
            />
            <label className="covered" htmlFor="region2">
              <svg className="icon -region2"><use xlinkHref="#svg_region2" /></svg>
            </label>

            <input
              className="hide"
              type="radio"
              id="region3"
              name="region_type"
              disabled={ !selectedRegion?.id }
              value="outside"
              checked={ isClipMode('outside') }
              onChange={ handleChangeClipMode }
            />
            <label className="outside" htmlFor="region3">
              <svg className="icon -region3"><use xlinkHref="#svg_region3" /></svg>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegionSettings;
